import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'

import { BlogPostFragment } from '@lib/umbraco/generated/types.generated'
import { FC } from 'react'
import s from './BlogPostSliderItem.module.scss'
export type BlogPostSliderItemProps = {
  blogPost: BlogPostFragment
  hideDescription?: boolean
}
const BlogPostSliderItem: FC<BlogPostSliderItemProps> = ({
  blogPost,
  hideDescription = false,
}) => {
  return (
    <div className={s.root}>
      <Media
        mediaWithCrops={blogPost.image}
        disableShopTheLook
        mediaClassName={s.image}
        className={s.imageContainer}
        sizes={'25vw'}
        scaleOnHover
      />
      <div className={s.content}>
        {blogPost.title && (
          <div className={s.title}>
            <TrustedHtml html={blogPost.title} />{' '}
          </div>
        )}
        {blogPost.bodyText && !hideDescription && (
          <div className={s.description}>
            <TrustedHtml html={blogPost.bodyText} />
          </div>
        )}
      </div>
    </div>
  )
}

export default BlogPostSliderItem
